import { Stack } from '@mui/material';
import { useShow } from '@refinedev/core';
import { Show } from '@refinedev/mui';
import { AuthorizedImage } from '../../../components/AuthorizedImage.tsx';
import { ReadOnlyField } from '../../../components/fields/ReadOnlyField.tsx';
import { Author } from '../../../types/index.ts';

export const AuthorShow = () => {
  const {
    query: { data, isLoading },
  } = useShow<Author>({
    resource: 'contents/authors',
    queryOptions: {
      select({ data }) {
        return {
          data: Author.parse(data),
        };
      },
    },
  });

  const record = data?.data;

  return (
    <Show isLoading={isLoading}>
      <Stack spacing={2}>
        <ReadOnlyField name="name" label="名前" fullWidth>
          {record?.name}
        </ReadOnlyField>
        <ReadOnlyField name="jobTitle" label="役職" fullWidth>
          {record?.jobTitle}
        </ReadOnlyField>
        <ReadOnlyField name="description" label="プロフィール" fullWidth>
          {record?.description}
        </ReadOnlyField>
        {record?.imageKey && (
          <ReadOnlyField label="画像" fullWidth>
            <AuthorizedImage
              src={`/.api/v1/contents/media/${record.imageKey}`}
              alt="サムネイル"
              style={{
                maxWidth: '300px',
                height: 'auto',
                aspectRatio: '1/1',
                objectFit: 'cover',
                border: '1px solid rgba(0, 0, 0, 0.23)',
                borderRadius: 1,
              }}
            />
          </ReadOnlyField>
        )}
      </Stack>
    </Show>
  );
};
